export const helpCenterURL = 'https://help.clear.co/';
